import { useCategoryStore } from '@/store/category'
import { getCategory } from '@/service/category'
import { AsyncDataKeys } from '@/constants/async-data-keys'

import { GtmEvent } from '@/types/gtm'

export function useCategory() {
  const route = useRoute()
  const categoryStore = useCategoryStore()

  const isTagsPage = computed(() => checkIfTagsPage(route.name))
  const tagId = computed(() => route.params.tagId as string)
  const categoryId = computed(() => (route.params.cid ?? route.params.tid) as string)
  const category = computed(() => categoryStore.categoryMap[Number(categoryId.value)] || {})
  const categoryName = computed(() => (isTagsPage.value ? categoryStore.tagDetail?.name : category.value.name))

  return { tagId, categoryId, category, categoryName }
}

export async function useCategoryPage() {
  const nuxtApp = useNuxtApp()

  const currentInst = getCurrentInstance()

  const categoryStore = useCategoryStore()

  const { categoryId, category } = useCategory()
  const { regionId } = useRegion()

  useEtgSeoSetting('category', { category })

  const filterOptionsPromise = useFilters({ categoryId })

  const categoryInfoPromise = useAsyncData(
    useAsyncDataKey(AsyncDataKeys.CATEGORY, [regionId.value, categoryId.value]),
    async () => {
      const { data } = await getCategory(categoryId.value, regionId.value)
      categoryStore.setToCategoryMap(data)
      return data
    },
    { watch: [regionId, categoryId] }
  )

  await Promise.all([categoryInfoPromise, filterOptionsPromise])

  onMounted(() => {
    nuxtApp.$trackEvent(GtmEvent.CATEGORY_VIEWED)
  }, currentInst)

  return { category }
}
